import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/site';

/** Sticky bottom CTA that appears once the hero CTA has scrolled out of view. */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-gold/30 bg-navy-deep/95 px-4 py-3 backdrop-blur transition-[transform,opacity] duration-200 ease-out sm:px-6 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-128" data-mp="gnsuvu46vsua">
      <div className="mx-auto flex max-w-3xl items-center gap-3" data-id="element-129" data-mp="14dde8e498s43">
        <div className="hidden min-w-0 flex-1 sm:block" data-id="element-130" data-mp="2b3qka74k2sy4">
          <p className="truncate font-serif text-base font-bold text-cream" data-id="element-131" data-mp="2f3soamxrjygk">Menopause Decision Desk™</p>
          <p className="text-[12px] font-medium text-cream/60" data-id="element-132" data-mp="21cvvow3u7h9i">
            6 Tomes + 5 Bonuses · <span className="line-through" data-id="element-133" data-mp="26bqqyxizqyai">$344</span>{' '}
            <span className="font-bold text-gold-light" data-id="element-134" data-mp="26a5uh2d495a0">$27 USD</span>
          </p>
        </div>
        <a href={CHECKOUT_URL} className="flex w-full animate-shake items-center justify-center gap-2 rounded-full bg-gold-light px-5 py-3.5 text-[14px] font-extrabold uppercase tracking-[0.05em] text-ink shadow-[0_8px_24px_-8px_rgba(0,0,0,0.6)] transition-[background-color,transform] duration-200 ease-out hover:bg-gold-soft active:scale-[0.98] sm:w-auto" data-id="element-135" data-mp="1rcwob2j5lwy8">
          Get instant access · $27
          <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-136" data-mp="3cppzdz9td1ih" />
        </a>
      </div>
    </div>;
}